/*
 * GF-PDP 5.6 (22/10/2026, Claude): also drives the buy-column "Pairs well with" (snippets/gf-ghep.liquid, GF-PW 1.0); You may also like
 *  excludes products already shown in ANY [data-gf-gy] block on the page.
 * GF-PDP 5.5 (21/10/2026, Claude) - behaviour for sections/gf-pdp-goi-y.liquid.
 *  Founder decision 21/10 18:01: canvas and ornament are never paired. The set block is now per product type:
 *  canvas "Build a gallery wall" (3 same-devotion canvases), ornament "Make it a set" (3 other ornaments),
 *  bags "Complete the set" (same-design wallet / Bible cover / tote).
 *  1) Add buttons: POST /cart/add.js (with the cart-items-component section ids, like Horizon's product-form.js) and a
 *     CartLinesUpdateEvent whose promise resolves with the new cart, so the cart drawer opens / re-renders and the header
 *     count updates exactly as after the main Add to cart.
 *  2) Canvas cards follow the main product's Frame + Size: when the same Frame/Size exists (and is available) on the
 *     suggested canvas, its Add button adds that variant; otherwise the cheapest No Frame variant. Price + label follow.
 *  3) "You may also like": loads /recommendations/products?intent=related&section_id=... once the block nears the
 *     viewport, keeps ONLY the same product group (canvas / ornament / leather goods), same exact type first, max 8, one row.
 *  4) Arrow buttons for the row on desktop.
 * Self-check in the console: window.GF_PDP.version === '5.5'.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

const VERSION = '5.6';
const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const MAX = 8;

function sectionIds() {
  const ids = [];
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.push(el.dataset.sectionId);
  });
  return ids;
}

function fmtMoney(cents, fmt) {
  const n = Number(cents) / 100;
  const group = (intStr, sep) => intStr.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
  const fixed = (digits, th, dec) => {
    const [i, d] = n.toFixed(digits).split('.');
    return group(i, th) + (d ? dec + d : '');
  };
  return String(fmt || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
    switch (k) {
      case 'amount_no_decimals':
        return fixed(0, ',', '.');
      case 'amount_with_comma_separator':
        return fixed(2, '.', ',');
      case 'amount_no_decimals_with_comma_separator':
        return fixed(0, '.', ',');
      case 'amount_with_apostrophe_separator':
        return fixed(2, "'", '.');
      default:
        return fixed(2, ',', '.');
    }
  });
}

function nhomLoai(type) {
  const t = String(type || '').toLowerCase();
  if (t.includes('canvas')) return 'canvas';
  if (t.includes('ornament')) return 'ornament';
  if (/handbag|tote|wallet|bible|leather/.test(t)) return 'leather';
  return t;
}

async function layGio() {
  const r = await fetch(`${ROOT}cart.js`, { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
  if (!r.ok) throw new Error(`cart ${r.status}`);
  return r.json();
}

async function them(btn) {
  const box = btn.closest('[data-gf-gy-bo]');
  const v = box && box.querySelector('[data-gf-gy-v]');
  const id = v && Number(v.value);
  if (!id) return;
  const goc = btn.textContent;
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');

  const d = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: String(id), quantity: 1 }],
      promise: d.promise,
    })
  );

  try {
    const r = await fetch(`${ROOT}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds().join(',') }),
    });
    const kq = await r.json();
    const cart = await layGio();
    const loi = !r.ok || kq.status;
    d.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'gf-pdp-set',
        sourceId: 'gf-pdp-set',
        itemCount: 1,
        sections: loi ? undefined : kq.sections,
        didError: !!loi,
      },
    });
    btn.textContent = loi ? kq.description || kq.message || 'Could not add' : 'Added';
  } catch (err) {
    d.reject(err);
    btn.textContent = 'Could not add';
    console.warn('[gf-pdp]', err);
  } finally {
    btn.removeAttribute('aria-busy');
    setTimeout(() => {
      btn.textContent = goc;
      btn.disabled = false;
    }, 2200);
  }
}

function giaTheoChon(sel) {
  const box = sel.closest('[data-gf-gy-bo]');
  const o = sel.options[sel.selectedIndex];
  const g = box && box.querySelector('[data-gf-gy-gia]');
  if (o && g && o.dataset.gia) g.textContent = o.dataset.gia;
}

/** Frame + Size currently selected on the main product's native variant picker (Horizon stays the source of truth). */
function chonChinh(pid) {
  const p =
    document.querySelector(`variant-picker[data-product-id="${pid}"]`) ||
    document.querySelector('variant-picker[data-template-product-match="true"]');
  const sel = {};
  if (!p) return sel;
  p.querySelectorAll('fieldset input:checked').forEach((i) => {
    if (i.dataset.optionName) sel[i.dataset.optionName] = i.value;
  });
  p.querySelectorAll('select').forEach((s) => {
    const o = s.selectedOptions[0];
    if (o && o.dataset.optionName) sel[o.dataset.optionName] = s.value;
  });
  return sel;
}

function dongBoCanvas(root) {
  const khoi = root.querySelector('[data-gf-gy-cv]');
  if (!khoi) return;
  const sel = chonChinh(root.dataset.pid);
  const fmt = root.dataset.fmt;
  khoi.querySelectorAll('[data-gf-gy-ga]').forEach((the) => {
    const js = the.querySelector('script[data-gf-gy-vs]');
    const inp = the.querySelector('[data-gf-gy-v]');
    if (!js || !inp) return;
    let vs = the.__gfVs;
    if (!vs) {
      try {
        vs = the.__gfVs = JSON.parse(js.textContent);
      } catch (err) {
        return;
      }
    }
    const v0 = vs.find((v) => String(v[0]) === the.dataset.v0);
    const khop =
      sel.Frame && sel.Size ? vs.find((v) => v[1] === sel.Frame && v[2] === sel.Size && v[4] === true) : null;
    const v = khop || v0;
    if (!v || inp.value === String(v[0])) return;
    inp.value = String(v[0]);
    const gia = the.querySelector('[data-gf-gy-gia]');
    const bt = the.querySelector('[data-gf-gy-bt]');
    if (gia) gia.textContent = fmtMoney(v[3], fmt);
    if (bt) bt.textContent = `${v[1]} · ${v[2]}`;
  });
}

function muiTen(khoi) {
  const ray = khoi.querySelector('[data-gf-gy-ray], .gf-gy__ray');
  const lui = khoi.querySelector('[data-gf-gy-lui]');
  const toi = khoi.querySelector('[data-gf-gy-toi]');
  if (!ray || !lui || !toi) return;
  const capNhat = () => {
    lui.disabled = ray.scrollLeft <= 2;
    toi.disabled = ray.scrollLeft + ray.clientWidth >= ray.scrollWidth - 2;
  };
  const buoc = (huong) => ray.scrollBy({ left: huong * ray.clientWidth * 0.9, behavior: 'smooth' });
  lui.addEventListener('click', () => buoc(-1));
  toi.addEventListener('click', () => buoc(1));
  ray.addEventListener('scroll', capNhat, { passive: true });
  capNhat();
}

async function taiYmal(root) {
  const khoi = root.querySelector('[data-gf-gy-ymal]');
  const ray = khoi && khoi.querySelector('[data-gf-gy-ray]');
  if (!khoi || !ray || !root.dataset.url) return;
  try {
    const loai = root.dataset.type || '';
    const nhom = root.dataset.nhom || nhomLoai(loai);
    // 5.6: loai SP da hien o MOI khoi [data-gf-gy] tren trang (Pairs well with trong cot mua + khoi bo cu).
    const bo = new Set(
      Array.from(document.querySelectorAll('[data-gf-gy]'))
        .flatMap((r) => (r.dataset.bo || '').split(','))
        .filter(Boolean)
    );
    const co = new Set();
    const hop = (a) =>
      a.dataset.id !== root.dataset.pid && !bo.has(a.dataset.id) && !co.has(a.dataset.id) && nhomLoai(a.dataset.type) === nhom;
    const cards = [];
    const r = await fetch(root.dataset.url, { credentials: 'same-origin' });
    if (r.ok) {
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const ben = doc.querySelector('[data-gf-gy-ymal-in]');
      if (ben) {
        ben.querySelectorAll('.gf-gy__the').forEach((a) => {
          if (hop(a)) {
            co.add(a.dataset.id);
            cards.push(a);
          }
        });
      }
    }
    // Same exact product type first, then the rest of the same group (bags: handbag / tote / wallet / Bible cover).
    const cung = cards.filter((a) => a.dataset.type === loai);
    const khac = cards.filter((a) => a.dataset.type !== loai);
    // Fewer than MAX of the same type: add same-type cards from the server-rendered fallback <template>.
    const du = khoi.querySelector('template[data-gf-gy-du]');
    if (du && cung.length < MAX) {
      Array.from(du.content.querySelectorAll('.gf-gy__the')).forEach((a) => {
        if (hop(a)) {
          co.add(a.dataset.id);
          cung.push(a);
        }
      });
    }
    // 5.7 (v6.0): leather goods mix types (max 4 of the same type first) so the row cross-sells wallets / totes / Bible covers.
    const chon = (nhom === 'leather' && khac.length ? cung.slice(0, 4).concat(khac, cung.slice(4)) : cung.concat(khac)).slice(0, MAX);
    if (!chon.length) return;
    chon.forEach((a) => {
      a.setAttribute('role', 'listitem');
      ray.appendChild(document.importNode(a, true));
    });
    khoi.hidden = false;
    muiTen(khoi);
  } catch (err) {
    console.warn('[gf-pdp] recommendations', err);
  }
}

function init(root) {
  if (root.__gfPdp) return;
  root.__gfPdp = true;
  root.addEventListener('click', (e) => {
    const b = e.target instanceof Element ? e.target.closest('[data-gf-gy-them]') : null;
    if (b) them(b);
  });
  root.addEventListener('change', (e) => {
    if (e.target instanceof HTMLSelectElement && e.target.matches('[data-gf-gy-v]')) giaTheoChon(e.target);
  });
  dongBoCanvas(root);
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (es) => {
        if (es.some((x) => x.isIntersecting)) {
          io.disconnect();
          taiYmal(root);
        }
      },
      { rootMargin: '600px 0px' }
    );
    io.observe(root);
  } else {
    taiYmal(root);
  }
}

function initAll() {
  document.querySelectorAll('[data-gf-gy]').forEach(init);
}

function dongBoTatCa() {
  document.querySelectorAll('[data-gf-gy]').forEach(dongBoCanvas);
}

if (!window.GF_PDP) {
  window.GF_PDP = { version: VERSION, init: initAll, sync: dongBoTatCa };
  document.addEventListener('shopify:section:load', initAll);
  // Main variant picker changed (Horizon radios, or the GF-CV tiles which drive them): re-read now and after Horizon's morph.
  document.addEventListener('change', (e) => {
    if (e.target instanceof Element && e.target.closest('variant-picker')) {
      requestAnimationFrame(dongBoTatCa);
      setTimeout(dongBoTatCa, 700);
    }
  });
  window.addEventListener('pageshow', dongBoTatCa);
}
initAll();
